// WikiPRIMATES - configuração pública de produção para Cloudflare Pages.
export const AppConfig = {
    appName: 'WikiPRIMATES',
    API_ENDPOINT: '/api',
    API_CITY: 'https://nominatim.openstreetmap.org/reverse',
    URL_APPLICATION: 'https://wikiprimes.pages.dev',
    FRONTEND: {
        PROD_MOD: true,
        MULTILINGUAL: false,
        DISPLAY_FOOTER: true,
        DISPLAY_TOPBAR: true,
        DISPLAY_SIDEBAR: true,
        DISPLAY_STATS: true,
        DISPLAY_BADGES: true,
        NEW_OBS_FORM_MODAL_VERSION: true,
    },
    META: {
        keywords: 'primatas brasil observações ciência cidadã biodiversidade',
    },
    signup: 'optional',
    about: false,
    email_contact: false,
    taxonDisplayImageWhenUnique: true,
    taxonSelectInputThreshold: 7,
    taxonAutocompleteInputThreshold: 30,
    taxonDisplaySciName: true,
    program_list_observers_names: true,
    program_list_sort: '-timestamp_create',
    imageUpload: {
        maxHeight: 1440,
        maxWidth: 1440,
        quality: 0.9,
    },
    VERIFY_OBSERVATIONS_ENABLED: false,
};
